/**
 * Uplifted pieces of `enums/labelItemSettings` (apps/web; apps/mobile has no `src/enums` at all).
 *
 * This folder MIRRORS the app file and holds only what has actually been needed so far:
 * `MASTER_DATA_PICKLIST_TYPES`, the `listType` in `BusinessSlice.getMasterDataPicklist`'s action
 * payload. The label vocabulary (print stages, delimiters, field keys) lives in
 * `itemLabelSettings/model`, not here.
 *
 * A FOLDER with one `index.ts`, not a split: the enum is
 * inert data with no platform behaviour, so there is nothing to diverge. A folder rather than a
 * bare file means a later split would be purely additive.
 *
 * ⚠️ A regular `enum`, deliberately NOT `const enum` — `packages/core` compiles with
 * `isolatedModules: true`, which cannot erase a `const enum` across files.
 *
 * This is the first module under a new `packages/core/enums/` root, mirroring `apps/web/src/enums`.
 */
export enum MASTER_DATA_PICKLIST_TYPES {
  ITEM_LABEL_TEMPLATE_FIELDS = "itemLabelTemplateFields",
  ITEM_LABEL_BARCODE_SPECIAL_FIELDS = "itemLabelBarcodeSpecialFields",
  INVENTORY_LABEL_SIZE = "inventoryLabelSize",
}

